import { LoaderCircle } from 'lucide-react';
import { cn } from '../../lib/cn';

export function Spinner({ label, className }: { label?: string; className?: string }) {
  return (
    <LoaderCircle
      role={label !== undefined ? 'status' : undefined}
      aria-label={label}
      aria-hidden={label === undefined}
      className={cn('size-4 animate-spin text-muted-foreground', className)}
    />
  );
}
